export const breakpoints = {
  xs: "(width <= 430px)",
  s: "(width <= 640px)",
  m: "(width <= 768px)",
  l: "(width <= 1024px)",
  xl: "(width <= 1280px)",
  xxl: "(width <= 1536px)",
} as const

export type Breakpoint = keyof typeof breakpoints
